export const cardDetails = {
    BANK_CARD: {
        AUTHORIZED: { fields: [] },
        AUTHORIZED_STANDALONE: { fields: [] },
        MAIN: { fields: [] },
    },
    CREDIT: {
        AUTHORIZED: { fields: [] },
        AUTHORIZED_STANDALONE: { fields: [] },
        BUSINESS: { fields: [] },
        MAIN: { fields: [] },
    },
    PREPAID: {
        PREPAID: { fields: [] },
    },
    VIRTUAL_CREDIT: {
        AUTHORIZED: { fields: [] },
        AUTHORIZED_STANDALONE: { fields: [] },
        MAIN: { fields: [] },
    },
    VIRTUAL_DEBIT: {
        AUTHORIZED: { fields: [] },
        AUTHORIZED_STANDALONE: { fields: [] },
        MAIN: { fields: [] },
    },
    INDOOR: {
        INDOOR: { fields: [] },
    },
};
